import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiConstants } from '../../common/constants/api-url.constant';
import { CategoryData } from '../../common/models/faq.model';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  private http = inject(HttpClient);
  private apiConstants = inject(ApiConstants);

  /** Get FAQ list by category, always returns a list (empty if null, undefined, or error) */
  getFAQList(category: string): Observable<CategoryData[]> {
    return this.http.get<CategoryData[] | null>(this.apiConstants.GET_FAQ_LIST(category)).pipe(
      map((data) => data ?? []), // convert null/undefined to empty array
      catchError((error) => {
        console.error('Error fetching FAQ list:', error);
        return of([]); // return empty array on error
      })
    );
  }
}
